<template>
    <div class="menu-bar-clock flex--no-shrink"
         :class="{'menu-bar-clock--large': largeTimeOnly}">
        <template v-if="largeTimeOnly">
            <span>{{ momentFilter(currentTime, 'h:mm A') }}</span>
        </template>
        <template v-else>
            <span class="menu-bar-clock__line">
                <span class="menu-bar-clock__date">{{ momentFilter(currentTime, 'ddd MMM Do') }}</span>
                {{ momentFilter(currentTime, 'h:mm A') }}
            </span>
            <small v-if="isDevelopment"
                   class="menu-bar-clock--red-text hidden-sm">
                <i class="fa-solid fa-code-branch"></i>
                {{ truncateFilter(branch, 16) }}
                <i class="ml-05 fa-solid fa-wrench"></i>
                {{ timeFilter(builtAt, true) }}
            </small>
            <small v-else-if="isBeta"
                   class="menu-bar-clock--red-text">
                <i class="fa-solid fa-circle-exclamation"></i>
                ProPoint BETA Version
            </small>
        </template>
    </div>
</template>

<script>
import { container } from '@/container';

export default {
    name: 'MenuBarClock',

    props: {
        largeTimeOnly: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            currentTime: new Date(),
        };
    },

    computed: {
        environment() {
            return container.appConfig.environment;
        },

        isBeta() {
            return container.appConfig.isBeta;
        },

        isDevelopment() {
            return this.environment === 'Development';
        },

        builtAt() {
            return container.appConfig.eposVersion;
        },

        branch() {
            // Try to be clever with the JIRA task in the branch name.
            const branchName = container.appConfig.eposBranch;
            let branchParts = branchName.split('-');
            if (branchParts.length >= 2) {
                return `${branchParts[0]}-${branchParts[1]}`;
            }

            return branchName;
        },
    },

    mounted() {
        setInterval(() => {
            this.currentTime = new Date();
        }, 3000); // Clock only updates every 3 seconds for performance.
    },
};
</script>

<style lang="less">
@import "../../../less/variables";

.menu-bar-clock {
    color: @white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    margin-right: 5px; // Extra space between the clock and buttons
    min-width: 0;

    small {
        margin-top: 0;
        font-size: 12px;
        line-height: 16px;

        i {
            font-size: 10px;
        }
    }

    &--red-text {
        color: @mid-red;
    }

    &--large {
        font-size: 30px;
        margin-right: 7px;
    }

    &__date {
        @media (min-width: @screen-sm-min) and (max-width: 800px) {
            display: none;
        }
    }
}

.menu-modal {
    .menu-bar-clock {
        align-items: center;
        color: @dt-navy;
        font-weight: bold;
        margin-bottom: 4px;

        small {
            font-weight: normal;
        }
    }
}
</style>
